
import { defineComponent } from 'vue';
import sidebarHeader from '@/components/sidebar/sidebarHeader.vue';
import { Data, UserRecord, ArtistItem } from '@/dataTypes/types';
import { useAuthStore } from '@/store/AuthStore';
import { useUserStore } from '@/store/UserStore';
import { useGalleryStore } from '@/store/GalleriesStore';
import { useArtistsStore } from '@/store/ArtistsStore';
import { usePrivateSellersStore } from '@/store/PrivateSellersStore';
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue';
import router from '@/router';
import { isObjEmpty } from '@/helpers/emptyObjectsChecker';

export default defineComponent({
  name: 'MainLayout',
  components: { sidebarHeader, SpinnerLoader },
  data() {
    const auth = useAuthStore();
    const user = useUserStore();
    window.authStore = auth;

    const gallery = useGalleryStore();
    const artist = useArtistsStore();
    const privateSeller = usePrivateSellersStore();
    return {
      auth,
      user,
      gallery,
      artist,
      privateSeller,
      drawer: true,
      isArtist: false,
      isGallery: false,
      isPrivateSeller: false,
      userInfo: {} as UserRecord,
      galleryInfo: {} as Data,
      artistInfo: {} as ArtistItem,
      role: '',
      name: '',
      userName: '',
      image: '',
      items: [
        { title: 'STATS', icon: 'mdi-view-dashboard' },
        { title: 'ARTISTS', icon: 'mdi-account-box' },
        { title: 'ARTWORKS', icon: 'mdi-palette' },
        { title: 'SHOWS', icon: 'mdi-store' },
        { title: 'OFFERS', icon: 'mdi-tag' },
        { title: 'SEARCH', icon: 'mdi-magnify' },
        { title: 'INBOX', icon: 'mdi-inbox-arrow-down' },
        { title: 'HELP', icon: 'mdi-help' },
        { title: 'SETTINGS', icon: 'mdi-cog' },
      ],
      artistItems: [
        { title: 'STATS', icon: 'mdi-view-dashboard' },
        { title: 'MY INFO', icon: 'mdi-account-box' },
        { title: 'ARTWORKS', icon: 'mdi-palette' },
        { title: 'HELP', icon: 'mdi-help' },
        { title: 'SETTINGS', icon: 'mdi-cog' },
      ],
      privateSellerItems: [
        { title: 'STATS', icon: 'mdi-view-dashboard' },
        { title: 'ARTISTS', icon: 'mdi-account-box' },
        { title: 'ARTWORKS', icon: 'mdi-palette' },
        { title: 'SEARCH', icon: 'mdi-magnify' },
        { title: 'HELP', icon: 'mdi-help' },
        { title: 'SETTINGS', icon: 'mdi-cog' },
      ],
      isLoading: true,
    };
  },
  async mounted() {
    if (!this.auth.isLoggedIn) {
      router.push('/login');
    } else {
      await this.assignRoles();

      this.drawer = this.user.drawer;

      if (this.isGallery) {
        await this.galleryProfile();
      }
      if (this.isArtist) {
        await this.artistProfile();
      }
      if (this.isPrivateSeller) {
        await this.privateSellerProfile();
      }
      this.isLoading = false;

      if (window.innerWidth < 768) {
        this.user.drawer = false;
        this.drawer = this.user.drawer;
      }
    }
  },
  computed: {
    currentItems() {
      if (this.isGallery) return this.items;
      if (this.isPrivateSeller) return this.privateSellerItems;
      if (this.isArtist) return this.artistItems;
      return null;
    },
  },
  methods: {
    logout() {
      this.auth.logout();
      router.push('/login');
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
      this.user.drawer = this.drawer;
    },
    getTitle() {
      const path = this.$route.path.substring(1).toUpperCase()?.split('/')[0];
      const greeting = `Hello ${this.name}`;
      const user = `${this.userName}`;
      if (this.userName) {
        return path || `${greeting} ${user}`;
      } else {
        return path || greeting;
      }
    },
    async assignRoles() {
      if (!this.auth.userInfo.id) {
        this.userInfo = await this.auth.fetchUserInfo();
      }
      this.userInfo = this.auth.userInfo;
      this.role = this.userInfo.role;
      this.isArtist = this.auth.userRole === 'artist';
      this.isGallery = this.auth.userRole === 'gallery';
      this.isPrivateSeller = this.auth.userRole === 'private_seller';
    },
    async galleryProfile() {
      if (isObjEmpty(this.gallery.galleryInfo)) {
        this.galleryInfo = await this.gallery.getInfo();
      }
      this.galleryInfo = this.gallery.galleryInfo;
      // this.name = this.galleryInfo?.gallery?.title || '';
      this.image = this.galleryInfo?.gallery?.image?.original || '';
      this.userName = this.galleryInfo?.user?.first_name || '';
    },
    async artistProfile() {
      if (isObjEmpty(this.artist.artistInfo)) {
        this.artistInfo = await this.artist.getInfo();
      }
      this.artistInfo = this.artist.artistInfo;
      // this.name = this.artistInfo?.first_name || '';
      this.image = this.artistInfo?.image?.original || '';
    },
    async privateSellerProfile() {
      // this.name = this.userInfo?.first_name || '';
      this.image = '';
      this.userName = this.userInfo?.first_name || '';
    },
  },
});
